
export default class

  # sound        # Sound
  # debounceSec
  # timePrevious

  constructor: (@sound, @debounceSec) ->

  play: (volume) ->
    diff = Date.now() - (@timePrevious || 0)
    if diff > @debounceSec * 1000
      @sound.play volume
      @timePrevious = Date.now()
